/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2019 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  $(document).ready(function () {

    $('.input-has-dropdown').on('focusin', function() {
      $(this).siblings('.search-widget__dropdown').addClass('open');
    });

    $('.input-has-dropdown').on('focusout', function() {
      $(this).siblings('.search-widget__dropdown').removeClass('open');
    });

  });
})(jQuery);
